import { Link } from "react-router-dom";

const quickLinks = [
  { label: "影片分类", to: "/films" },
  { label: "放映动态", to: "/screenings" },
  { label: "特色技术", to: "/technology" },
  { label: "观影指南", to: "/guide" },
  { label: "关于我们", to: "/about" },
  { label: "联系我们", to: "/contact" },
];

const socials = [
  { icon: "ri-wechat-line", label: "微信公众号" },
  { icon: "ri-weibo-line", label: "微博" },
  { icon: "ri-bilibili-line", label: "哔哩哔哩" },
  { icon: "ri-youtube-line", label: "视频号" },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-foreground-800">
      <div className="max-w-content mx-auto px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500 text-background-50 text-xl">
                <i className="ri-planet-line" />
              </span>
              <span className="font-heading font-bold text-lg text-foreground-950">球幕影院</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-md">
              以穹顶沉浸技术重新定义观影。我们用 360 度球幕、激光投影与环绕声场，
              把每一部影片变成一次身临其境的旅程。
            </p>
            <div className="flex items-center gap-3 mt-6">
              {socials.map((s) => (
                <button
                  key={s.label}
                  type="button"
                  aria-label={s.label}
                  className="w-10 h-10 flex items-center justify-center rounded-md bg-background-200/60 text-foreground-800 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-lg`} />
                </button>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 mb-4">
              <span>快速链接</span>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 hover:text-accent-500 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 mb-4">
              <span>联系方式</span>
            </h4>
            <ul className="flex flex-col gap-3 text-sm text-foreground-600">
              <li className="flex items-start gap-2.5">
                <i className="ri-phone-line text-accent-500 mt-0.5" />
                400-826-2026
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-mail-line text-accent-500 mt-0.5" />
                hello@domecinema.cn
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-map-pin-line text-accent-500 mt-0.5" />
                上海市浦东新区星海大道 88 号穹顶艺术中心
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-time-line text-accent-500 mt-0.5" />
                每日 09:30 - 22:30
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200/40 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">© 2026 球幕影院 Dome Cinema. 保留所有权利。</p>
          <p className="text-xs text-foreground-600">
            本站放映信息为演示示例，实际场次以现场公示为准
          </p>
        </div>
      </div>
    </footer>
  );
}